///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.roles = abcsetup.roles || {};
abcsetup.roles.index = abcsetup.roles.index || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.roles.index = {
    init: function() {
        $(document).ready(function() {
            $('#roles-table').on('init.dt', function() {
                const createButton = $('.buttons-create');
                if (createButton.length && !$('.buttons-delete-multiple').length) {
                    const deleteButtonHtml = `
                        <button type="button" class="btn btn-danger btn-sm buttons-delete-multiple">
                            <i class="fa fa-trash"></i> Delete
                        </button>
                    `;
                    createButton.after(deleteButtonHtml);
                }
            });

            if (!$('#deleteRolesModal').length) {
                $('body').append(`
                    <div class="modal fade" id="deleteRolesModal" tabindex="-1" role="dialog" aria-labelledby="deleteRolesModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="deleteRolesModalLabel">Delete Roles</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <p>Are you sure you want to delete the following roles?</p>
                                    <ul id="rolesToDeleteList"></ul>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                                    <button type="button" class="btn btn-danger" id="confirmDeleteRoles">Delete</button>
                                </div>
                            </div>
                        </div>
                    </div>
                `);
            }

            // Delete multiple roles
            $(document).on('click', '.buttons-delete-multiple', function() {
                const selectedIds = [];
                const selectedItems = [];

                // Retrieve all selected role IDs, user names, and role names
                $('.role-checkbox:checked').each(function() {
                    const roleId = $(this).val();
                    const userName = $(this).closest('tr').find('td:nth-child(2)').text(); 
                    const roleName = $(this).closest('tr').find('td:nth-child(5)').text(); 
                    
                    selectedIds.push(roleId);
                    selectedItems.push(`${userName} - ${roleName}`);
                });

                if (selectedIds.length === 0) {
                    alert('Please select at least one role to delete.');
                    return;
                }

                // Populate the modal with the user-role pairs
                $('#rolesToDeleteList').empty();
                selectedItems.forEach(function(item) {
                    $('#rolesToDeleteList').append('<li>' + item + '</li>');
                });

                $('#deleteRolesModal').modal('show');

                // Confirm deletion
                $('#confirmDeleteRoles').off('click').on('click', function() {
                    // Set the role IDs in the hidden form and submit it
                    $('#destroyMultipleRoleIds').val(selectedIds.join(','));
                    $('#destroyMultipleRolesForm').submit();
                });
            });
        });
    }
}
